
<Card
  :class="variant === SitterCardVariantTypes.Small && 'small-sitter-card'"
  :clickable="isClickable"
  :href="profileUrl"
  :customClasses="customClasses"
>
  <AlertBanner v-if="availability" :status="validStatus">
    <template #icon>
      <CalendarIcon />
    </template>

    Available: {{ availabilityText }}
  </AlertBanner>
  <AlertBanner v-if="shouldShowAvailabilityAlert" class="-m-16 mb-16" :status="6">
    <div>You sent an availability check</div>
  </AlertBanner>
  <div v-if="isLoading"><SitterCardLoadingSkeleton /></div>
  <div v-else class="p-16">
    <div v-if="variant === SitterCardVariantTypes.Base" class="flex flex-col">
      <div class="w-full flex flex-row border-b-2 border-solid border-grey-divider-subdued pb-4 last:pb-0 last:border-b-0">
        <div class="w-full pr-16 overflow-hidden">
          <h2 class="text-h3 text-ellipsis overflow-hidden whitespace-nowrap">{{ name }}</h2>
          <p v-if="yearsExperience && yearsExperience !== 0" class="text-body">{{ yearsExperiencePluralized }}</p>
          <p class="text-body">{{ locationText }}</p>
          <StarRating v-if="totalRatings > 0" :count="totalRatings || 0" :average="avgRating" />
        </div>
        <div>
          <a v-if="photoUploadAvatar" class="relative" aria-label="Photo upload" href="/sitter/photo_upload#/sitter_upload">
            <Avatar photoUploadIcon size="mega" name="" emptyAlt />
            <div class="flex justify-center items-center w-32 h-32 absolute top-14 right-0" aria-label="Add profile photo">
              <AddFilled />
            </div>
          </a>
          <Avatar v-else :name="name" :image-url="photoUrl" size="mega" />
        </div>
      </div>
      <p v-if="truncatedDescription" id="sitter-card-description" class="text-small">{{ truncatedDescription }}</p>
      <div v-if="hasEnhancedBgc || hasBgc || hasMvr || hasFirstAid || hasCpr || hasRate" class="flex">
        <div v-if="hasIdv || hasEnhancedBgc || hasBgc || hasMvr || hasFirstAid || hasCpr">
          <ul class="mt-16 inline-flex">
            <li v-if="hasIdv">
              <IDVBadge />
            </li>
            <li v-if="hasEnhancedBgc" id="sitter-card-enhanced-bgc">
              <EnhancedBackgroundCheckBadge />
            </li>
            <li v-if="hasBgc" id="sitter-card-bgc" :class="hideBGCBadge ? 'hidden md:block' : ''">
              <BackgroundCheckBadge />
            </li>
            <li v-if="hasMvr" id="sitter-card-mvr">
              <MotorVehicleRecordBadgeVue />
            </li>
            <li v-if="hasFirstAid" id="sitter-card-first-aid">
              <FirstAidBadge />
            </li>
            <li v-if="hasCpr" id="sitter-card-cpr">
              <CPRBadge />
            </li>
          </ul>
        </div>
        <span v-if="hasRate" class="ml-auto self-center">
          <span class="profile-card__rate-unit">$</span>
          <span class="profile-card__rate-value">{{ computedMin }}–{{ computedMax }}</span
          >/hr
        </span>
      </div>
    </div>
    <div v-if="variant === SitterCardVariantTypes.Small" class="w-full">
      <div class="h-[120px]">
        <img
          class="h-[120px] absolute rounded-t-xl left-0 top-0 object-cover overflow-hidden w-full"
          :src="photoUrl"
          :alt="photoAltText"
          :aria-label="photoAltText"
        />
      </div>
      <div>
        <h3 class="text-h5">{{ sitterNameTruncated }}</h3>
        <p>{{ yearsExperiencePluralized }}</p>
        <p v-if="hasRate">${{ computedMin }}–{{ computedMax }}/hr</p>
        <StarRating v-if="totalRatings > 0" :count="totalRatings || 0" :average="avgRating" />
      </div>
    </div>
  </div>
</Card>
